
import MarketAnalysisService from "@/service/MarketAnalysisService";
import FormatterService from '@/service/FormatterService'
import { backendExceptionHandler } from "@/mixins";
import subscriptionConstants from '@/constants/subscription.constants';

const { subscribeProductKeys } = subscriptionConstants;

export default {
    name: 'PersonalizedMarketReportCard',
    mixins: [backendExceptionHandler],

    data() {
        return {
            content: '',
            createdAt: null,
            isLoading: true,
            errorMessage: null,
            activeRequest: null
        }
    },

    computed: {
        isSubscribedFinAgent() {
            return this.$store.state.account.subscribedProductIds?.includes(subscribeProductKeys.finAgent);
        },
    },

    methods: {
        async fetchPersonalizedMarketReport() {          
            try {
                if (!this.isSubscribedFinAgent) {
                    const exception = new Error();
                    exception.response = {
                        status: 403,
                    };
                    throw exception;
                }
                const locale = this.$getCurrentLocale()
                const axiosSource = this.$axios.CancelToken.source();
                this.activeRequest = { cancel: axiosSource.cancel, msg: "Cancel..." };

                const res = await this.marketAnalysisService.getPersonalizedMarketSummary(locale, axiosSource.token)

                if (res.body) {
                    this.content = res.body
                    const dateOpt = {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                    }
                    const dateLocale = {
                        'en': 'en-CA',
                        'de': 'de-DE',
                        'fr': 'fr-FR',
                        'es': 'es-ES',
                    }
                    this.createdAt = this.format.date({ locale: dateLocale[locale], date: res.created }, dateOpt)
                } else {
                    this.content = null
                }
            } catch (error) {
                this.content = null
                this.handleBackendException(error, this.$t('common.errors.generalError'))
            } finally {
                this.activeRequest = null
                this.isLoading = false
            }
        }
    },

    created() {
        this.marketAnalysisService = new MarketAnalysisService(this.$axios);
        this.format = new FormatterService();
        this.fetchPersonalizedMarketReport();
    },

    beforeDestroy() {
        if (this.activeRequest) {
            this.activeRequest.cancel()
        }
    }
}
